import Page520 from "./page-520";
const UNKNOWN_ERROR_PATH = "/520";
export { UNKNOWN_ERROR_PATH, Page520 };
